export { default } from './Reducer'
